<template>
  <div data-name="mapbox-geo-line" />
</template>

<script>
export default {
  name: 'MapboxGeoLine',

  props: {
    mapContext: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      activeLayer: false,
    }
  },

  created() {
    window.addEventListener('mp_drawLine', this.drawLine)
  },

  destroyed() {
    window.removeEventListener('mp_drawLine', this.drawLine)
  },

  methods: {
    drawLine(event) {
      if (this.activeLayer) this.cleanup()
      this.activeLayer = true

      this.mapContext.addSource('pointToPoint', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: event.detail.points,
          },
        },
      })
      this.mapContext.addLayer({
        id: 'closestPath',
        type: 'line',
        source: 'pointToPoint',
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': '#229df5',
          'line-width': 4,
          'line-dasharray': [3, 2],
        },
      })
    },
    cleanup() {
      this.mapContext.removeLayer('closestPath')
      this.mapContext.removeSource('pointToPoint')
    },
  },
}
</script>
